/*
 * Developed for EPSON AMERICA INC. by Softeq Development Corporation
 * http://www.softeq.com
 */

import _isFunction from 'lodash/isFunction'

const loadingObjects = [
  {
    loading: true,
    loaded: false,
  },
  {
    loading: false,
    loaded: true,
  },
  {
    loading: false,
    loaded: false,
  },
]

const mapper = key => (handler, index) => (state, action) => {
  const newState = {
    ...state,
    [key]: {
      ...state[key],
      ...loadingObjects[index],
    },
  }
  if (_isFunction(handler)) {
    newState[key].value = handler(state, action, state[key].value)
  }
  return newState
}

export const loadingWrapper = (key, handlers) => handlers.map(mapper(key))
